import { render, staticRenderFns } from "./p5s2salesDashboard.vue?vue&type=template&id=3c738e4c"
import script from "./p5s2salesDashboard.vue?vue&type=script&lang=js"
export * from "./p5s2salesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports